module.exports = __webpack_public_path__ + "static/media/IMG_0053.81aec88c.JPG";